import { createTransportLogger, MessageDirection, unwrap, wrap } from "./shared";
const log = createTransportLogger("Editor");
/**
 * Editor transport assumes we are loaded in an iframe in the editor
 */ export class EditorTransport {
    constructor({ targetWindow, targetOrigin }){
        this._targetWindow = targetWindow;
        this._targetOrigin = targetOrigin;
    }
    _targetWindow;
    _targetOrigin;
    postMessage(messages) {
        const wrappedOutgoingMessage = wrap(messages, MessageDirection.FromPaywall);
        log.debug("Wrapped message for editor", wrappedOutgoingMessage);
        this._targetWindow.postMessage(wrappedOutgoingMessage, this._targetOrigin);
        log.info("Sent message to editor via postMessage");
    }
    _handlers = [];
    addListener(handler) {
        this._handlers.push(handler);
    }
    /**
   * In order for `window.removeEventListener` to work we need to pass the same
   * exact function that we used for `addListener`. This is a way to cache that
   * value because `.bind(this)` mutates the original `_onRawMessageRecevied`
   *
   * This also implicitly tracks state about if we're listening or not,
   * `undefined` meaning not listening
   *
   */ _listeneingRef = undefined;
    startListening() {
        if (this._listeneingRef !== undefined) {
            return;
        }
        this._listeneingRef = this._onRawMessageReceived.bind(this);
        window.addEventListener("message", this._listeneingRef);
    }
    stopListening() {
        if (this._listeneingRef === undefined) {
            return;
        }
        window.removeEventListener("message", this._listeneingRef);
        this._listeneingRef = undefined;
    }
    _onRawMessageReceived(event) {
        // TODO: Origin check
        if (event.data && typeof event.data === "string") {
            let events = unwrap(event.data, MessageDirection.ToPaywall);
            events.forEach((message)=>{
                this.accept(message);
            });
        }
    }
    accept(message) {
        if (this._listeneingRef) {
            this._handlers.forEach((handler)=>handler(message));
        }
    }
}
